var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHideBet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8867 13.5555C18.3302 14.2917 17.4784 15.2902 16.4419 16.1003C15.4002 16.9144 14.2213 17.5 13 17.5C11.7787 17.5 10.5998 16.9144 9.5581 16.1003C8.52157 15.2902 7.66984 14.2917 7.11333 13.5555C6.78865 13.1259 6.7984 12.5549 7.13654 12.1403C7.69833 11.4514 8.54703 10.5312 9.57588 9.78682C10.6084 9.03979 11.7806 8.5 13 8.5C14.2194 8.5 15.3916 9.03979 16.4241 9.78682C17.453 10.5312 18.3017 11.4514 18.8635 12.1403C19.2016 12.5549 19.2114 13.1259 18.8867 13.5555Z",
    stroke: "#FBEEEE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 2,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideBet);
export default __webpack_public_path__ + "static/media/hide-bet.92c2bb2b2eec63d3a34b405dffba0aab.svg";
export { ForwardRef as ReactComponent };